module.exports = __webpack_public_path__ + "img/logo.2212a6ee.png";